import React from "react";
import { Box } from "@mui/joy";
import ScrollableListPageLayout from "../../common/ScrollableListPageLayout";
import TrainingsTemplatePageHeader from "./TrainingsTemplatePageHeader";
import { trainingsTemplateDashboardLayoutSx } from "../../../styles/globalStyles";

export type TrainingsTemplateDashboardFrameProps = {
  isLoading: boolean;
  headerLeft: React.ReactNode;
  headerRight: React.ReactNode;
  children: React.ReactNode;
};

export default function TrainingsTemplateDashboardFrame({
  isLoading,
  headerLeft,
  headerRight,
  children,
}: TrainingsTemplateDashboardFrameProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "90vh" }}>
      <TrainingsTemplatePageHeader left={headerLeft} right={headerRight} />
      <ScrollableListPageLayout isLoading={isLoading} sx={trainingsTemplateDashboardLayoutSx}>
        {children}
      </ScrollableListPageLayout>
    </Box>
  );
}
